import React, { useState, useEffect } from 'react';

import {
    MenuItem,
    Box,
    ListItemIcon,
    IconButton,
    Tooltip,
} from '@mui/material';
import { Logout, Settings } from '@mui/icons-material';

import { useAuth } from 'core/contexts';
import { CustomMenu } from 'components';
import { useLocation, useNavigate } from 'react-router-dom';
import { SINGLE_NAVIGATION_PATHS } from '../../../../constants/single-navigation-paths';
import { styles } from './header-helpers';
import { Avatar } from '@biq/apex-ui';

export const AccountMenu = (): React.JSX.Element => {
    const location = useLocation();
    const navigate = useNavigate();
    const { logout, getUserName, getUserEmail } = useAuth();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [initials, setInitials] = useState<string>('');
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (): void => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (getUserName()?.length) {
            const getFullName = getUserName().split(' ');
            setInitials(getFullName[0].charAt(0) + getFullName[1].charAt(0));
        } else {
            setInitials(getUserEmail().charAt(0));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getUserName(), getUserEmail()]);

    const navigateToSettingsPage = (): void => {
        navigate(SINGLE_NAVIGATION_PATHS.SETTINGS, {
            state: location.pathname,
        });
    };

    return (
        <>
            <Box>
                <Tooltip title='Account settings'>
                    <IconButton
                        onClick={handleClick}
                        size='small'
                        sx={styles.accountMenuIcon}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup='true'
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <Avatar initial={initials} sizes={'large'} />
                    </IconButton>
                </Tooltip>
            </Box>
            <CustomMenu
                anchorEl={anchorEl}
                id='account-menu'
                open={open}
                onClose={handleClose}
                onClick={handleClose}
            >
                <MenuItem onClick={navigateToSettingsPage}>
                    <ListItemIcon>
                        <Settings fontSize='small' />
                    </ListItemIcon>
                    Settings
                </MenuItem>
                <MenuItem onClick={(): void => logout()}>
                    <ListItemIcon>
                        <Logout fontSize='small' />
                    </ListItemIcon>
                    Logout
                </MenuItem>
            </CustomMenu>
        </>
    );
};
